window.HomeHeroBanner = (randomId) => {
    return {
        swiper: null,
        init() {
          setTimeout(() => {
            this.swiper = new Swiper("#swiper-" + randomId, {
              slidesPerView: 1,
              loop: true,
              autoplay: {
                delay: 7000,
                disableOnInteraction: false,
              },
              grabCursor: true,
              spaceBetween: 0,
              pagination: {
                el: ".swiper-pagination-" + randomId,
                clickable: true,
                // type: "bullets",
                renderBullet: function (index, className) {
                    return '<div class="' + className + '"><div class="dot"></div></div>'
                }
              },
              a11y: true,
            });
          }, 0);
        },
      };
};
